export default "__VITE_ASSET__67c5cb4a__"